<template>
  <img :src="iconSrc" :alt="alt" class="feature-icon" :class="sizeClass" />
</template>

<script>
const ICONS = {
  simple: require('@/assets/icons/simple.svg'),
  service: require('@/assets/icons/service.svg'),
  local: require('@/assets/icons/local.svg'),
  iterate: require('@/assets/icons/iterate.svg'),
  stable: require('@/assets/icons/stable.svg'),
  fast: require('@/assets/icons/fast.svg'),
  support: require('@/assets/icons/support.svg'),
  update: require('@/assets/icons/update.svg'),
  shield: require('@/assets/icons/shield.svg'),
  search: require('@/assets/icons/search.svg'),
  history: require('@/assets/icons/history.svg'),
  keyboard: require('@/assets/icons/keyboard.svg'),
  image: require('@/assets/icons/image.svg'),
  lock: require('@/assets/icons/lock.svg'),
  mouse: require('@/assets/icons/mouse.svg'),
  pin: require('@/assets/icons/pin.svg'),
  star: require('@/assets/icons/star.svg'),
  sparkle: require('@/assets/icons/sparkle.svg'),
  pdf: require('@/assets/icons/pdf.svg'),
  video: require('@/assets/icons/video.svg'),
  puzzle: require('@/assets/icons/puzzle.svg'),
  yinyang: require('@/assets/icons/yinyang.svg'),
  calendar: require('@/assets/icons/calendar.svg'),
  heart: require('@/assets/icons/heart.svg'),
  'plugin-free': require('@/assets/icons/plugin-free.svg'),
  'ad-free': require('@/assets/icons/ad-free.svg'),
  'scroll-capture': require('@/assets/icons/scroll-capture.svg'),
  stitch: require('@/assets/icons/stitch.svg'),
  ocr: require('@/assets/icons/ocr.svg'),
  tag: require('@/assets/icons/tag.svg')
}

export default {
  name: 'FeatureIcon',
  props: {
    name: { type: String, required: true },
    alt: { type: String, default: '' },
    size: { type: String, default: 'md' }
  },
  computed: {
    iconSrc() {
      return ICONS[this.name] || ICONS.shield
    },
    sizeClass() {
      return `feature-icon--${this.size}`
    }
  }
}
</script>

<style scoped>
.feature-icon {
  display: block;
  object-fit: contain;
}
.feature-icon--sm { width: 20px; height: 20px; }
.feature-icon--md { width: 24px; height: 24px; }
.feature-icon--lg { width: 32px; height: 32px; }
.feature-icon--xl { width: 40px; height: 40px; }
</style>
